import React,{useState,useEffect} from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Typography,Tooltip } from '@mui/material';
import AccountInquiryDetails from "./AccountInquiryDetails";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FilterListOff } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
const AccountInquiryList = ({ data,noRecordMessage,setData,setSearchInput }) => {
    const [openRowId, setOpenRowId] = useState(null);
    const formatPhoneNumber = (number) => {
        const cleaned = ('' + number).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `${match[1]}-${match[2]}-${match[3]}`;
        }
        return number;
    };

    const truncateText = (text, length) => {
        if (text.length <= length) return text;
        return text.substring(0, length) + '...';
    };
    useEffect(() => {
        // Reset openRowId when new data is loaded
        setOpenRowId(null);
      }, [data]);
    const handleRowExpandToggle = (row) => {
        // If the row clicked is already expanded, close it
        if (openRowId === row.id) {
          setOpenRowId(null); 
          // Collapse if clicked again
        } else {
          
          setOpenRowId(row.id); // Expand the clicked row
          row.toggleExpanded(row.id); 
        }
      };
      const handleAddEdit = (row) => {
    
        handleRowExpandToggle(row);
      };
    //   const handleAddEdit = (row) => {
    //     row.toggleExpanded();

    // };
    const handleRefresh = ()=>{
        setData([]);
        setSearchInput('')
    }
    const columns = [
        {
            accessorKey: "AccountNumber",
            header: "Account #",
            Cell: ({ row }) => (
                <span onClick={() => handleAddEdit(row)} >
                    <Typography sx={{ ml: 1 ,textAlign:"left",color: "#4fa4ef", cursor: "pointer", fontSize: 16}}>{row.original.AccountNumber}</Typography>

                </span>
            ),
        },
        {
            accessorKey: 'AccountHolder',
            header: 'Account Holder',
             filterFn: (row, columnId, filterValue) => {
                    const value = row.getValue(columnId);
                    return value.toLowerCase().includes(filterValue.toLowerCase());
                },
            sortingFn: (rowA, rowB) => {
                const [firstA, ...restA] = rowA.original.AccountHolder.split(' ');
                const [firstB, ...restB] = rowB.original.AccountHolder.split(' ');

                const lastA = restA.join(' ') || '';
                const lastB = restB.join(' ') || '';

                const firstCompare = firstA.localeCompare(firstB, undefined, { sensitivity: 'base' });
                if (firstCompare !== 0) return firstCompare;

                return lastA.localeCompare(lastB, undefined, { sensitivity: 'base' });
            }
        },
        { accessorKey: "ServiceAddress", header: "Service Address" ,
            Cell: ({ cell }) => (
                <Box>
                    {truncateText(cell.getValue(), 20)}
                </Box>
            ),
        },
        { accessorKey: "BillingAddress", header: "Billing Address",
            Cell: ({ cell }) => (
                <Box>
                    {truncateText(cell.getValue(), 20)}
                </Box>
            ),
         },
        {
            accessorKey: "PhoneNumber",
            header: "Phone Number",
            Cell: ({ cell }) => (
                <Box >
                    {formatPhoneNumber(cell.getValue())}
                </Box>
            ),
        },
        {
            accessorKey: "AmountDue",
            header: "Account Balance",
            Cell: ({ cell }) => (
                <Box >
                    {`$ ${cell.getValue()}`}
                </Box>
            ),
        },

    ];



    const table = useMaterialReactTable({
        columns,
        data: noRecordMessage ? [] : data,
        enableHiding: false,
        enableSortingRemoval: false,
        columnFilterDisplayMode: 'popover',
        enableFullScreenToggle: false,
        enableColumnActions: false,
        paginationDisplayMode: 'pages',
        enableRowActions: false,
        enableRowSelection: false,
        enableExpandAll: false,
        positionExpandColumn: 'first',
        positionToolbarAlertBanner: 'none',
        autoResetPageIndex: false,
        getRowId: (row) => row.UserId, // Ensure unique IDs for rows
        displayColumnDefOptions: {
            'mrt-row-expand': {
                header: "",
                size: 10, // make the expand column wider
                muiTableHeadCellProps: {
                    sx: {
                        display: 'none', // Hide the expand column
                    },
                },
                muiTableBodyCellProps: {
                    sx: {
                        display: 'none', // Hide the expand column
                    },
                },
            },
        },
        initialState: {
            columnOrder: [
                'mrt-row-expand',
                'AccountNumber',
                'AccountHolder',
                'ServiceAddress',
                'BillingAddress',
                "PhoneNumber",
                "AmountDue"
            ],

        },
        renderTopToolbarCustomActions: () => (
            <Box
              sx={{
                display: 'flex',
                gap: '16px',
                padding: '8px',
                flexWrap: 'wrap',
              }}
            >
              <Tooltip title="Clear Filter" className='Deactivate'>
                <div>
                  <IconButton 
                  onClick={() => {
                    handleRefresh()
                  }}  
                  >
                    <FilterListOff variant="contained" color="secondary" />
                  </IconButton>
                </div>
              </Tooltip>
           
            </Box>
          ),
        renderDetailPanel: ({ row }) => (
            openRowId === row.id && (
            <Box sx={{ padding: 2 }}>
                <AccountInquiryDetails rowData={row.original} />
            </Box>
            )
        ),
        muiExpandButtonProps: {
            sx: {
                display: 'none',
            },
        },
        localization: {
            noRecordsToDisplay: noRecordMessage || 'No records to display.',
        },
    });

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MaterialReactTable table={table} />
            </LocalizationProvider>
        </>
    );
};

export default AccountInquiryList;